import styled, {css} from "styled-components"

import FocusOnKeyboard from "../Button/helpers/FocusOnKeyboard"
import {RouterLink} from "../Link"

export const StyledFocusOnKeyboard = styled(FocusOnKeyboard)`
  ${({theme}) => css`
    padding: ${theme.spacing.one} ${theme.spacing.three};
  `}
`

export const StyledRouterLink = styled(RouterLink)`
  ${({theme}) => css`
    display: flex;
    padding: ${theme.spacing.one} ${theme.spacing.three};
  `}
`

export const DropdownOptionsWrapper = styled.div`
  ${({theme}) => css`
    cursor: pointer;
    border-radius: 8x;
    box-shadow: ${theme.shadows.high};
    position: absolute;
    top: 32px;
    z-index: 1;
    background-color: ${theme.colors.greys.white};
    div {
      padding: ${theme.spacing.one} ${theme.spacing.three};
    }
    a,
    div {
      white-space: nowrap;
      &:hover {
        text-decoration: none;
        background-color: ${theme.colors.greys.grey03};
        span {
          color: ${theme.colors.primary2};
        }
      }
    }
  `}
`
